import { useNavigate } from 'react-router-dom'
import { IconPaths, Permission } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from '../../../../../../components'
import { useAuth } from '../../../../../auth'
import { useListFilters } from '../../core/ListFiltersProvider'

export const FormulariosListToolbar = () => {
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const { filters } = useListFilters()
  const { t } = useT()

  const isAdmin = currentUser?.grupo?.nome === Permission.Admin
  // O Admin cria o formulário dentro da instituição selecionada no filtro.
  const semEmpresa = isAdmin && !filters.empresa
  const hint = semEmpresa
    ? `Selecione uma ${t('empresa.label.lowercase')} para adicionar um formulário`
    : undefined

  const handleAdd = () => navigate(`criar${isAdmin ? `?empresaId=${filters.empresa?.value}` : ''}`)

  return (
    <Button
      onClick={handleAdd}
      icon={IconPaths.Add}
      className='btn-primary'
      disabled={semEmpresa}
      title={hint}
    >
      {t('common.add')}
    </Button>
  )
}
